import React from "react"
import { FormattedMessage } from "react-intl"
import StandardList from "../../common/listing/list.component"
import InputUnitOfMeasure from "../../common/unit-of-measure/input.component"
import PricingRow from "../../state/pricing/PricingRow"


type OwnProps = {
    updateMaxCapacity: (n: number) => void
    updateRowLimit: (r: PricingRow, n: number) => void
    rows: PricingRow[]
    rowLimits: object
    maxCapacity?: number
}
const RowsLimitEditComponent = (props: OwnProps) => {
    return (
        <StandardList
            footer={createFooter(props.updateMaxCapacity, props.rows.length > 0, props.maxCapacity)}
            smallLine={true}
            headers={createHeaders()}
            rows={
                props.rows.map(createListRow(props.updateRowLimit, props.rowLimits))
            }
        />
    )
}

const createHeaders = () => {
    return ([
        <p key={0}>
            <FormattedMessage
                id="price-list.edit.validation_rules.row_limit.item_title_label"
                defaultMessage="Title"
            />
        </p>,
        <p key={1} className="text-right">
            <FormattedMessage
                id="price-list.edit.validation_rules.row_limit.item_limit_label"
                defaultMessage="Limit"
            />
        </p>
    ])
}

const createFooter = (updateMaxCapacity, hasRows, maxCapacity?: number) => (
    <div className="row col-12 justify-content-end align-items-center m-0 p-0">
        <p className="m-0 pr-3">
            <FormattedMessage 
                id="price-list.edit.validation_rules.max_capacity_label"
                defaultMessage="Max Capacity"
            />
        </p>
        <InputUnitOfMeasure
            style={{width: "100px"}}
            key={"price-list-limit-max-capacity"}
            debounced={true}
            disabled={!hasRows}
            onChange={n => updateMaxCapacity(Number(n))}
            value={maxCapacity}
            format={"short"}
        />
    </div>
)

const createListRow = (updateRowLimit, rowLimits: object) => (row: PricingRow) => {
    return ([
        <p key={0} className="m-0">{row.getTitle()}</p>,
        <div key={1} className="row justify-content-end">
            <InputUnitOfMeasure
                style={{width: "100px"}}
                key={row.getId()}
                debounced={true}
                onChange={n => updateRowLimit(row, Number(n))}
                value={rowLimits[row.getId()] ?? 0}
                format={"short"}
            />
        </div>
    ]
    )
}

export default RowsLimitEditComponent


// WEBPACK FOOTER //
// ./src/price-list/components/RowsLimitEditComponent.tsx